import React, { useState, useEffect } from 'react';
import AccountSidebar from '../components/AccountSidebar';
import TwoFactorAuthContent from '../components/TwoFactorAuthContent';
import api from '../services/api';

export default function TwoFactorAuth() {
    const [is2FAEnabled, setIs2FAEnabled] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [qrCodeUrl, setQrCodeUrl] = useState('');

    useEffect(() => {
        const check2FAStatus = async () => {
            try {
                const response = await api.get2FactorStatus();
                const isEnabled = response.data;
                setIs2FAEnabled(isEnabled);
                
                if (!isEnabled) {
                    try {
                        const qrResponse = await api.generateQrCode();
                        setQrCodeUrl(qrResponse.qrCodeUrl);
                    } catch (qrError) {
                        console.error('Error generating QR code:', qrError);
                    }
                }
                
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching 2FA status:', error);
                setIsLoading(false);
            }
        };

        check2FAStatus();
    }, []);

    if (isLoading) {
        return (
            <div className="account-layout acc-layout-mobile">
                <div className="container">
                    <div className="account-wrapper">
                        <AccountSidebar activeItem="guvenlik-ayarlari" />
                        <div className="account-content">
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Yükleniyor...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="guvenlik-ayarlari" />
                    <TwoFactorAuthContent is2FAEnabled={is2FAEnabled} qrCodeUrl={qrCodeUrl} />
                </div>
            </div>
        </div>
    );
}
